import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import OrganizationService from '../Services/OrganizationService';
import '../CSS/OrganizationView.css';

const OrganizationView = () => {
  const { organizationId } = useParams();
  const navigate = useNavigate();

  const [organization, setOrganization] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    OrganizationService.getAllOrganizations().then(res => {
      const org = res.data.find(
        o => o.organizationId === Number(organizationId)
      );
      if (org) {
        setOrganization(org);
        setName(org.organizationName);
      }
      setLoading(false);
    });
  }, [organizationId]);

  const handleUpdate = async () => {
    await OrganizationService.updateOrganization(organizationId, {
      organizationName: name
    });
    setOrganization({ ...organization, organizationName: name });
    setEditMode(false);
  };

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this organization?')) return;
    await OrganizationService.deleteOrganization(organizationId);
    navigate('/');
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="org-view-container">
      {/* HEADER */}

      <div className="org-view-header">
  <h2>View Organization</h2>

  <button className="back-btn" onClick={() => navigate(-1)}>
    ← Back
  </button>
</div>




      {/* CARD */}
      <div className="org-view-card">
<div className={`org-card-actions ${editMode ? 'edit-mode' : ''}`}>
          {!editMode ? (
            <>
              <button className="delete-btn" onClick={handleDelete}>
                 Delete
              </button>
              <button className="edit-btn" onClick={() => setEditMode(true)}>
                 Edit
              </button>
            </>
          ) : (
            <>
              <button className="save-btn" onClick={handleUpdate}>
                Save
              </button>
              <button
                className="cancel-btn"
                onClick={() => {
                  setName(organization.organizationName);
                  setEditMode(false);
                }}
              >
                Cancel
              </button>
            </>
          )}
        </div>

        <div className="org-form-grid">
          <div className="form-group">
            <label>Organization Name</label>
            <input
              type="text"
              value={name}
              readOnly={!editMode}
              onChange={e => setName(e.target.value)}
            />
          </div>

        </div>
      </div>
    </div>
  );
};

export default OrganizationView;
